// Core
import { GlobalStyle } from "assests/styles/globalStyles";
import React from "react";
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// Others
import AppRouter from "routes";

// Styles


export function App() {
  return (<>
    <GlobalStyle />
    <AppRouter />
  </>
  );
}

export default App;
